const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FD9A0C"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D2CFCE"
    },
    cx: 256,
    cy: 256,
    r: 195.235
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C8484"
    },
    d: "M295.484,332.366h-11.253V108.494l-0.001,0.001l-71.905,41.156 c-4.045,2.316-5.447,7.472-3.132,11.517c2.316,4.046,7.474,5.446,11.516,3.133l7.061-4.042v172.106h-11.253 c-4.661,0-8.44,3.779-8.44,8.44s3.779,8.44,8.44,8.44h78.966c4.662,0,8.44-3.779,8.44-8.44S300.145,332.366,295.484,332.366z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8A2A2"
    },
    d: "M272.868,403.453c-4.211,0-7.853-3.147-8.369-7.434c-0.556-4.627,2.745-8.83,7.373-9.386 c34.984-4.203,67.363-22.77,88.837-50.939c2.828-3.707,8.12-4.422,11.829-1.595c3.707,2.826,4.421,8.121,1.596,11.828 c-24.224,31.774-60.763,52.72-100.248,57.463C273.544,403.432,273.204,403.453,272.868,403.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8A2A2"
    },
    d: "M239.131,403.453c-0.336,0-0.675-0.02-1.017-0.062c-39.486-4.744-76.025-25.689-100.247-57.463 c-2.826-3.707-2.111-9.002,1.595-11.828c3.706-2.824,9.002-2.112,11.828,1.595c21.475,28.169,53.855,46.735,88.838,50.939 c4.628,0.556,7.929,4.759,7.373,9.386C246.985,400.304,243.343,403.453,239.131,403.453z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC066"
    },
    d: "M320.185,480.788c-3.641,0-7.003-2.375-8.088-6.045c-1.323-4.47,1.227-9.165,5.696-10.489 C409.28,437.152,473.178,351.514,473.178,256S409.28,74.848,317.791,47.745c-4.47-1.323-7.018-6.02-5.696-10.489 c1.323-4.467,6.016-7.023,10.489-5.695c47.393,14.039,90.025,43.576,120.044,83.17c31.029,40.926,47.429,89.776,47.429,141.268 s-16.4,100.342-47.428,141.268c-30.019,39.594-72.651,69.131-120.044,83.17C321.786,480.676,320.978,480.788,320.185,480.788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC066"
    },
    d: "M191.815,480.788c-0.794,0-1.6-0.113-2.4-0.35c-47.393-14.039-90.024-43.576-120.043-83.17 C38.344,356.342,21.943,307.493,21.943,256s16.401-100.342,47.428-141.268c30.019-39.594,72.651-69.131,120.043-83.17 c4.473-1.328,9.165,1.225,10.489,5.695c1.324,4.47-1.225,9.165-5.695,10.489C102.72,74.848,38.822,160.486,38.822,256 s63.898,181.152,155.387,208.255c4.468,1.323,7.018,6.02,5.695,10.489C198.817,478.412,195.457,480.788,191.815,480.788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC066"
    },
    d: "M239.112,39.45c-4.378,0-8.079-3.381-8.408-7.817c-0.344-4.649,3.145-8.696,7.794-9.039 c5.838-0.432,11.725-0.65,17.501-0.65c5.776,0,11.663,0.218,17.501,0.65c4.648,0.343,8.138,4.391,7.795,9.039 c-0.343,4.647-4.371,8.147-9.038,7.794c-10.852-0.802-21.665-0.802-32.514,0C239.532,39.442,239.321,39.45,239.112,39.45z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTails);
export default __webpack_public_path__ + "static/media/tails.6d0a6baee2061136be0019bcf265ec82.svg";
export { ForwardRef as ReactComponent };